/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './follow.defs.js'
export * as $defs from './follow.defs.js'
